import configdata from "../../config.json";
import { vendorSliceAction } from "./VendorSlice";
import { getApi } from "../BaseApi";
import { getOnlyValueFromSelectObject } from "../UseAbleFun";
import { appLevelSliceActions } from "../AppLevelApi/AppLevelSlice";
export const getAllVendorItems = () => {
  return async (dispatch) => {
    dispatch(appLevelSliceActions.setLoadingState());
    const res = await getApi("get", `${configdata.SERVER_URL}/api/vendors`);

    dispatch(appLevelSliceActions.setLoadingState());
    dispatch(vendorSliceAction.getAllVendor(res.data.vendors));
  };
};
export const createVendorItem = (data) => {
  return async (dispatch) => {
    const res = getOnlyValueFromSelectObject(data);

    dispatch(appLevelSliceActions.setLoadingState());
    const resData = await getApi(
      "post",
      `${configdata.SERVER_URL}/api/vendors/store`,
      res.form
    );

    if (resData?.error) {
      if (resData?.errorType === "single") {
        dispatch(
          appLevelSliceActions.setError({ msg: resData.message, isError: true })
        );
      } else {
        dispatch(
          vendorSliceAction.setErrorData({
            message: resData.message,
            isError: true,
          })
        );
      }

      dispatch(appLevelSliceActions.setLoadingState());
      return;
    }
    dispatch(
      vendorSliceAction.setErrorData({
        message: {},
        isError: false,
      })
    );
    dispatch(appLevelSliceActions.setIsSuccess(true));

    dispatch(vendorSliceAction.setInitialData());
    dispatch(appLevelSliceActions.setLoadingState());
    dispatch(getAllVendorItems());
  };
};
export const getDataForEdit = (id) => {
  return async (dispatch) => {
    dispatch(vendorSliceAction.setErrorData({ message: {}, isError: true }));
    dispatch(appLevelSliceActions.setLoadingState());
    const res = await getApi(
      "get",
      `${configdata.SERVER_URL}/api/vendors/edit/${id}`
    );
    dispatch(appLevelSliceActions.setLoadingState());
    const data = { ...res.data.vendor[0] };

    data.type = {
      value: `${data.type}`,
      label: data.type === "leaf" ? "Leaf" : "Raw Mateiral",
      type: "type",
    };
    data.status = {
      value: `${data.status}`,
      label: data.status === "active" ? "Active" : "Deactive",
      type: "status",
    };
    dispatch(vendorSliceAction.getVendorDataEdit(data));
  };
};

export const updateVendorItem = (data) => {
  const res = getOnlyValueFromSelectObject(data);
  return async (dispatch) => {
    dispatch(appLevelSliceActions.setLoadingState());
    let resData = await getApi(
      "post",
      `${configdata.SERVER_URL}/api/vendors/update/${data.id}`,
      res.form
    );

    if (resData?.error) {
      if (resData?.errorType === "single") {
        dispatch(
          appLevelSliceActions.setError({ msg: resData.message, isError: true })
        );
      } else {
        dispatch(
          vendorSliceAction.setErrorData({
            message: resData.message,
            isError: true,
          })
        );
      }

      dispatch(appLevelSliceActions.setLoadingState());
      return;
    }
    dispatch(
      vendorSliceAction.setErrorData({
        message: {},
        isError: false,
      })
    );
    dispatch(appLevelSliceActions.setIsSuccess(true));

    dispatch(appLevelSliceActions.setLoadingState());
    dispatch(vendorSliceAction.setInitialData());
    dispatch(getAllVendorItems());
  };
};

export const deleteVendorItem = (id) => {
  return async (dispatch) => {
    dispatch(appLevelSliceActions.setLoadingState());
    await getApi("get", `${configdata.SERVER_URL}/api/vendors/delete/${id}`);
    dispatch(appLevelSliceActions.setIsSuccess(true));
    dispatch(appLevelSliceActions.setLoadingState());
  };
};
